import { Box, forwardRef } from '@chakra-ui/react'

export const Section = forwardRef(
    /**
     * @param {import('@chakra-ui/react').BoxProps} props
     * @param {any} ref
     * @returns
     */
    (props, ref) => {
        return (
            <Box ref={ref} as="section" bg="white" px={4} py={6} {...props} />
        )
    }
)
